module.exports = __webpack_public_path__ + "media/images/icons/vendors/photo-5e6b9ad3f3782c8f0e12a134c8b3905e.png";